import {
	AccessTokenResponse,
	ConfirmRequest,
	ForgotPasswordRequest,
	LoginRequest,
	RegisterRequest,
	ResendConfirmationEmailRequest,
	ResetPasswordRequest,
	UserResponse,
} from '../types/types';
import { HttpResponse, makeRequest } from './index';

const endpoint = 'Auth';

export const login = async (request: LoginRequest, useCookies: boolean, useSessionCookies: boolean): Promise<HttpResponse<AccessTokenResponse>> => {
	const result = await makeRequest<LoginRequest, AccessTokenResponse>(
		`${endpoint}/login?useCookies=${useCookies}&useSessionCookies=${useSessionCookies}`,
		request,
		'post',
	);
	return result;
};

export const logout = async (): Promise<HttpResponse<string>> => {
	const result = await makeRequest<null, string>(`${endpoint}/logout`, null, 'post');
	return result;
};

export const register = async (request: RegisterRequest): Promise<HttpResponse<UserResponse>> => {
	const result = await makeRequest<RegisterRequest, UserResponse>(`${endpoint}/register`, request, 'post');
	return result;
};

export const confirmUser = async (request: ConfirmRequest): Promise<HttpResponse<string>> => {
	const result = await makeRequest<ConfirmRequest, string>(`${endpoint}/confirm`, request, 'post');
	return result;
};

export const resendConfirmation = async (request: ResendConfirmationEmailRequest): Promise<HttpResponse<string>> => {
	const result = await makeRequest<ResendConfirmationEmailRequest, string>(`${endpoint}/resendConfirmationEmail`, request, 'post');
	return result;
};

export const forgotPassword = async (request: ForgotPasswordRequest): Promise<HttpResponse<string>> => {
	const result = await makeRequest<ForgotPasswordRequest, string>(`${endpoint}/forgotPassword`, request, 'post');
	return result;
};

export const resetPassword = async (request: ResetPasswordRequest): Promise<HttpResponse<string>> => {
	const result = await makeRequest<ResetPasswordRequest, string>(`${endpoint}/resetPassword`, request, 'post');
	return result;
};
